module.exports = "/_next/static/images/Trend03Visual@2x-b9aee13d9cb42642d08a2ff7c47c87ae.png";